@if (isOpened) {
    <div class="info-box box-border p-4" @slideUp>
        <div class="flex justify-between items-center">
            <div>
                <ca-icon icon="info" class="ca-icon-s-20-p-0-f-20 me-2"></ca-icon>
                <span class="panel-title">{{ 'INFO_BOX.TITLE' | translate }}</span>
            </div>
            <ca-icon icon="cross" class="cursor-pointer" id="close-panel" (click)="close()"></ca-icon>
        </div>
        <p class="mt-2 mb-0">
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna
            aliquyam erat, sed diam voluptua.
        </p>
    </div>
}
